import {
    FETCH_NAVIGATION_REQUEST,
    FETCH_NAVIGATION_SUCCESS,
    FETCH_NAVIGATION_FAILURE,
    CREATE_SUCCESS,
    UPDATE_SUCCESS,
    SET_SELECTED_WISHLIST,
} from '../constants';
import createNavigationState from '../utils/createNavigationState';

const initialState = {
    loading: false,
    error: null,
    wishlistsList: [],
    inventory: {},
};

export default function (state = initialState, action = {}) {
    const { data, type } = action;

    switch (type) {
        case FETCH_NAVIGATION_REQUEST:
            return {
                ...state,
                error: null,
                loading: true,
            };

        case FETCH_NAVIGATION_SUCCESS: {
            const result = createNavigationState(state, action.body, action.options);

            return {
                ...state,
                ...result,
                error: null,
                loading: false,
            };
        }

        case FETCH_NAVIGATION_FAILURE:
            return {
                ...state,
                ...data,
                error: action.body
                    ? {
                          body: action.body,
                          headers: action.headers, // TODO: White list headers
                          status: action.status,
                      }
                    : action.type,
                loading: false,
            };

        case CREATE_SUCCESS: {
            const { uniqueID, descriptionName } = action.body;
            const { locale } = action.options;

            const newWishlist = {
                id: uniqueID,
                name: descriptionName,
                isPrimary: false,
                isPrivate: true,
                totalItems: '0',
                href: `/${locale}/wishlist/${uniqueID}`,
                selected: '',
            };

            const primaryWishlist = state.wishlistsList[0];

            return {
                ...state,
                wishlistsList: [primaryWishlist, newWishlist, ...state.wishlistsList.slice(1)],
                error: null,
            };
        }

        case UPDATE_SUCCESS: {
            const { descriptionName } = action.options;
            const { uniqueID: updatedWishlistId } = action.body;

            return {
                ...state,
                wishlistsList: descriptionName
                    ? state.wishlistsList.map((wishlist) => ({
                          ...wishlist,
                          name: wishlist.id === updatedWishlistId ? descriptionName : wishlist.name,
                      }))
                    : state.wishlistsList,
                error: null,
            };
        }

        case SET_SELECTED_WISHLIST: {
            const { selectedId } = action;

            return {
                ...state,
                wishlistsList: state.wishlistsList.map((wishlist) => ({
                    ...wishlist,
                    selected: wishlist.id === selectedId ? 'selected' : '',
                })),
            };
        }

        default:
            return state;
    }
}
